const BASE_URL = process.env.REACT_APP_API_URL;

const api = async (endpoint, options = {}) => {
  const token = localStorage.getItem('crm_token');
  
  const headers = {
    ...options.headers,
  };

  // Add Auth token if available
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Auto-set Content-Type to JSON if body is object and not FormData
  if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    options.body = JSON.stringify(options.body);
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  return response;
};

export default api;
